import { LeftOutlined } from '@ant-design/icons';
import { Button, Space, Typography, theme } from 'antd';
import { useTranslation } from 'react-i18next';

interface WorkspaceModalHeaderProps {
  readonly title: string;
  readonly onBack: () => void;
}

/**
 * Secondary header rendered at the top of a modal body inside the right
 * panel (property view, draft form). Carries a back-chevron that
 * returns the panel to its library state, and a human-readable title of
 * the current focus.
 */
export default function WorkspaceModalHeader({
  title,
  onBack,
}: WorkspaceModalHeaderProps) {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <Space
      align="center"
      size="small"
      style={{
        width: '100%',
        padding: `${token.paddingXS}px 0 ${token.paddingXS}px 0`,
        marginBottom: token.marginSM,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
      }}
    >
      <Button
        type="text"
        size="small"
        icon={<LeftOutlined />}
        onClick={onBack}
        aria-label={t('workspace.back')}
      />
      <Typography.Text strong style={{ fontSize: 14 }}>
        {title}
      </Typography.Text>
    </Space>
  );
}
